import React from 'react';
import './Header.css';
import Innov from './innov.png'
import Logo from './image.png'
export default function Header() {
    return (
        <header className="admin-header-container">
            <div className="header-content">
                {/* Logo de l'entreprise */}
                <div className="logo logo-section">
                    <img src={Innov} alt="Logo Entreprise" className="logo" />
                </div>

                {/* Séparateur ou Texte de Partenariat */}
                <div className="partnership-badge">
                    <span className="x-separator">✕</span>
                    <span className="partnership-text">PARTENARIAT</span>
                </div>

                {/* Ton Logo */}
                <div className="logo-section">
                    <img src={Logo} alt="Mon Logo" className="logo" />
                </div>
            </div>
        </header>
    );
}